import React from 'react';

function IngredientAdditiveInfo(props) {
  const { additivesInfoHTML } = props;
  return (
    <div id="ingredientadditiveinfo-container">
      {additivesInfoHTML.length > 0 && (
        <div id="ingredientadditiveinfo-content" style={{ margin: '0px 10px' }}>
          {additivesInfoHTML}
        </div>
      )}
    </div>
  );
}

export default IngredientAdditiveInfo;
